import { Component, inject } from '@angular/core';
import { MatDialogRef, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { IceButtonComponent } from '@app/shared/components/atoms/ice-button/ice-button.component';
import { CdkScrollable } from '@angular/cdk/scrolling';

@Component({
  selector: 'app-maximum-number-of-subscriptions-dialog',
  templateUrl: './maximum-number-of-subscriptions-dialog.component.html',
  styleUrls: ['./maximum-number-of-subscriptions-dialog.component.scss'],
  imports: [CdkScrollable, MatDialogContent, MatDialogActions, IceButtonComponent, MatDialogClose],
})
export class MaximumNumberOfSubscriptionsDialogComponent {
  dialogRef = inject<MatDialogRef<MaximumNumberOfSubscriptionsDialogComponent>>(MatDialogRef);
}
